import type { MuiCityOption } from '../../types/forms/MuiCityOption';
import type { City } from '../../types/models/City';
import type { Mapper } from '../../types/mappers/Mapper';

export class MuiCityMapper implements Mapper<City, MuiCityOption> {
    mapToView(cityList: Array<City> | City): Array<MuiCityOption> | MuiCityOption {
        if (Array.isArray(cityList)) {
            return cityList.map((city) => {
                return {
                    label: city.name,
                    id: city.cityId.toString(),
                    zone: city.zone,
                    code: city.code,
                    zoneColor: city.zoneColor,
                };
            });
        }

        return {
            label: cityList.name,
            id: cityList.cityId.toString(),
            zone: cityList.zone,
            code: cityList.code,
            zoneColor: cityList.zoneColor,
        };
    }

    mapToModel(data: MuiCityOption | MuiCityOption[]): Array<City> | City {
        throw new Error('Exception: not implemented');
    }
}
